"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _toConsumableArray2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.regexp.split");
var _billButtons = _interopRequireDefault(require("@/views/userCenter/componens/billButtons.vue"));
var _index = _interopRequireDefault(require("@/components/filterColumn/index.vue"));
var _index2 = _interopRequireDefault(require("@/components/Pagination/index.vue"));
var _billConsigneeApplication = require("@/api/userCenter/billConsigneeApplication");
var _index3 = _interopRequireDefault(require("@/components/BackToTop/index.vue"));
var _appDetDlg = _interopRequireDefault(require("@/views/user/roleCertificationApplication/components/appDetDlg .vue"));
var _bookingHistoryJp = require("@/api/bookSpace/bookingHistoryJp");
var _booking = require("@/api/bookSpace/booking");
var _index4 = _interopRequireDefault(require("@/components/SailScheduleVessName/index.vue"));
var _validate = require("@/utils/validate");
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import { Descriptions ,DescriptionsItem } from 'element-ui';
var _default = exports.default = {
  name: "",
  components: {
    sailScheduleVessName: _index4.default,
    AppDetDlg: _appDetDlg.default,
    BackToTop: _index3.default,
    filterColumn: _index.default,
    billButtons: _billButtons.default,
    Pagination: _index2.default
    // Descriptions,DescriptionsItem
  },
  data: function data() {
    return {
      sizeList: [],
      showSave: true,
      showSubmit: false,
      detialType: '',
      tableCostData: [],
      hotSettings: {
        dragCheck: true,
        height: '500',
        width: 'auto',
        stretchH: 'all',
        manualColumnResize: true,
        language: 'zh-CN',
        licenseKey: '8a4e2-659ac-afa83-14d2e-cb603',
        readOnly: true,
        columnSorting: true,
        showSelection: true,
        fixedColumnsLeft: 1,
        fragmentSelection: 'cell',
        copyPaste: false
      },
      statusHeadData: [{
        value: '0',
        label: 'PENDING'
      }, {
        value: '1',
        label: 'ACCEPTEDv'
      }, {
        value: '2',
        label: 'WAITING'
      }, {
        value: '3',
        label: 'CANCELED'
      }, {
        value: '4',
        label: 'BKG LOCKED'
      }, {
        value: '5',
        label: 'BKG UNLOCKED'
      }, {
        value: '6',
        label: 'M/F COMPLETED'
      }, {
        value: '7',
        label: 'FRT COMPLETED'
      }, {
        value: '8',
        label: 'CHANGING'
      }, {
        value: '9',
        label: 'CANCELING'
      }, {
        value: '10',
        label: 'DRAFT'
      }, {
        value: '11',
        label: 'APPLYING'
      }, {
        value: '12',
        label: 'M/F LOCKED'
      }],
      listQuery: {
        currentPage: 1,
        pageSize: 20,
        total: 0
      },
      custerInfo: {
        companyName: '',
        activateEmail: '',
        accountName: '',
        fax: '',
        tel: ''
      },
      detailForm: {
        input1: 'GLOBAL LOGISTICS CO., LTD',
        input2: 'dong',
        input3: 'zhangsna',
        input4: '132111',
        input5: '1',
        input6: ''
      },
      cargoGroupList: [],
      options: [{
        value: '20GP',
        label: '20GP'
      }],
      value: '20GP',
      options2: [{
        value: 'AUTO PARTS',
        label: 'AUTO PARTS'
      }],
      unitList: [{
        value: 'C',
        label: 'C'
      }, {
        value: 'F',
        label: 'F'
      }],
      contactTypeCodeList: [{
        value: 'EM',
        label: 'EM'
      }, {
        value: 'FX',
        label: 'FX'
      }, {
        value: 'TE',
        label: 'TE'
      }],
      preCoolList: [{
        value: 0,
        label: 'No'
      }, {
        value: 1,
        label: 'Yes'
      }],
      ventList: [{
        value: 'CLOSE',
        label: 'Close'
      }, {
        value: 'OPEN',
        label: 'Open'
      }],
      value2: 'AUTO PARTS',
      autoTrWidth: '',
      radio: '',
      textarea: '',
      detailsId: '',
      saveFormId: '',
      sailScheduleDialogVisible: false,
      isOtherVoyage: false,
      statusLabel: 'NEW',
      addFormData: {},
      deliveryDocumentCompany: '',
      webBookingHead: {
        bookingDate: '',
        bookingCancelFlag: 0,
        cargoSize: 0,
        dataSource: 3,
        actualSize: 0,
        releaseStatus: 0,
        rowStatus: 4,
        bookingDept: 2,
        refNo: "",
        remarkFromOutbound: "",
        freeTimeNo: "NIL",
        // serviceLineCode: "NST",
        // vesselCode: "SNNT",
        // vesselName: "SNL NANTONG",
        // vesselNameCn: "",
        // voyageLeg: "N",
        // voyageNo: "2430",
        carrier: "SIT",
        // 用户信息
        // companyName:'',
        // tel:'',
        // activateEmail:'',
        // accountName:'',
        // fax:'',

        por: '',
        pol: '',
        pod: '',
        del: '',
        paidType: 0,
        remark: '',
        deliveryDocumentCompany: '',
        // 默认选择
        transportationTerms: 'CY-CY',
        bookingType: 1,
        tsFlag: 0,
        dgCheckFlag: '0',
        socCheckFlag: '0',
        wpCheckFlag: '0',
        rfCheckFlag: '0',
        akCheckFlag: '0',
        deliveryDocumentMethod: 1,
        webBkPreContainers: [{
          // BK_PRE_CONTAINER_WEB_ID
          // bkPreContainerWebId
          // bkPreContainerWebId: "",
          commodityCode: "",
          containerType: "20GP",
          quantity: "1",
          rowStatus: 4

          // rowStatus:4,
          // containerType:'20GP',
          // quantity:'',
          // commodityCode:'',
        }],
        webBkCustomers: [{
          rowStatus: 4,
          customerName: '',
          customerCode: '',
          customerType: 0,
          webBkCustomerCatalogs: [{
            rowStatus: 4,
            sequence: 1,
            printOrder: 1,
            catalogContent: ''
          }]
        }],
        webBkExtends: [{
          brokerContacts: "",
          brokerEmail: "",
          brokerFax: "",
          brokerTel: "",
          customsBroker: "",
          isSendBrokerEmail: '0',
          isSendBrokerFax: '0',
          rowStatus: 4

          // rowStatus:4,
          // customsBroker:'',
          // contactCustomer:'',
          // brokerTel:'',
          // brokerFax:'',
          // brokerEmail:'',
          // isSendBrokerFax:'0',
          // isSendBrokerEmail:'0',
        }],
        // WebBkCargo
        webBkCargos: [{
          cargoDesc: "",
          // 默认赋值
          cargoSize: 0,
          grossWeight: "",
          netWeight: 0,
          packageDesc: "CTNS",
          packageType: "CTNS",
          quantity: 0,
          rowStatus: 4,
          shippingMark: "N/M",
          webBkImos: [{
            rowStatus: 4,
            classType: '',
            unSeriseNo: '',
            quantity: '',
            packageDesc: '',
            packageCode: '',
            grossWeight: '',
            netWeight: '',
            flashPoint: '',
            casNo1: '',
            casNo2: '',
            casNo3: '',
            cargoSize: '',
            temperature: '',
            intakeNum: '',
            contactName: '',
            contactNumber: '',
            contactTypeCode: '',
            approveKey: '',
            componentDesc: '',
            property: '',
            emergencyTelNo: ''
          }],
          webBkReefers: [
            // {
            //   rowStatus:4,
            //   rateBase:'C',
            //   temperature:'',
            //   preCool:'',
            //   intakeNum:'',
            //
            //   // intakeNum:'CLOSE',
            //   // rateBase:'C',
            // }
          ]
        }],
        webBkAks: [{
          rowStatus: 4,
          containerType: '',
          akLength: '',
          akWidth: '',
          akHigth: '',
          akGrossWeight: ''
        }],
        webBkFeeItems: [{
          rowStatus: 4
        }],
        webBkHgs: [{
          rowStatus: 4
        }],
        // webBkRoutings:[
        //   {
        //     rowStatus:4,
        //   }
        // ],
        webBkSocs: [{
          rowStatus: 4
        }],
        webBkYards: [{
          rowStatus: 4
        }]
      },
      deleteIndexWebBkPreContainers: -1,
      deleteIndexWebBkReefers: -1,
      deleteIndexWebBkAks: -1,
      deleteIndexWebBkImos: -1,
      packageTypeList: [],
      packageDescList: [{
        value: 'I',
        label: 'I'
      }, {
        value: 'II',
        label: 'II'
      }, {
        value: 'III',
        label: 'III'
      }],
      voyagesData: [
        // {
        //   vesselName:'',
        //   voyageNo:'',
        //   voyageLeg:'',
        //   polEtaHidden:'',
        //   polEta:'',
        //   etd:'',
        //   eta:'',
        //   vesselCode:'',
        //   vesselNameCn:'',
        //   serviceLineCode:'',
        //   lineType:'',
        //   tripNumber:'',
        //   carrier:'',
        //   polHidden:'',
        //   podHidden:'',
        // }
      ],
      shippinTermList: [{
        value: 'CY-CY',
        label: 'CY-CY'
      }, {
        value: 'CY-CFS',
        label: 'CY-CFS'
      }, {
        value: 'CY-FO',
        label: 'CY-FO'
      }, {
        value: 'CFS-CFS',
        label: 'CFS-CFS'
      }, {
        value: 'CFS-CY',
        label: 'CFS-CY'
      }],
      shippinModeList: [{
        value: 2,
        label: 'EMPTY'
      }, {
        value: 1,
        label: 'FCL CARGO'
      }, {
        value: 0,
        label: 'LCL CARGO'
      }],
      emergencyTelNoData: [{
        emergencyTelNo: ''
      }],
      polNameList: {
        porName: '',
        polName: '',
        podName: '',
        delName: '',
        delName1: ''
      },
      issueTypList: [{
        value: 1,
        label: 'BILL OF LOADING'
      }, {
        value: 2,
        label: 'SEA WAYBILL'
      }],
      isTableItemTsFlag: '0',
      format: 'V.'
    };
  },
  watch: {
    'webBookingHead.rfCheckFlag': {
      handler: function handler(newVal) {
        if (newVal === 0) {
          this.webBookingHead.webBkCargos[0].webBkReefers = [];
        } else if (newVal === 1 && (0, _validate.validateNull)(this.webBookingHead.webBkCargos[0].webBkReefers)) {
          this.webBookingHead.webBkCargos[0].webBkReefers = [{
            rowStatus: 4,
            rateBase: 'C',
            temperature: '',
            preCool: '',
            intakeNum: ''
            // intakeNum:'CLOSE',
            // rateBase:'C',
          }];
        }
      },
      immediate: true // 立即执行一次监听器
    },
    'webBookingHead.tsFlag': {
      handler: function handler(newVal) {
        var _this = this;
        if (newVal === 0 && !(0, _validate.validateNull)(this.polNameList.delName1)) {
          this.getPortCode(this.polNameList.delName1).then(function (res) {
            _this.webBookingHead.del = res;
          });
        }
      },
      immediate: true // 立即执行一次监听器
    },
    'polNameList.delName': {
      handler: function handler(newVal) {
        var _this2 = this;
        if (this.webBookingHead.tsFlag === 1) {
          this.getPortCode(this.polNameList.delName).then(function (res) {
            _this2.webBookingHead.del = res;
          });
        }
      },
      immediate: true // 立即执行一次监听器
    }
  },
  created: function created() {
    var _this3 = this;
    this.webBookingHead.bookingDate = this.formatDate();
    this.getNowJpUserInfo();
    this.detialType = this.$route.query.type;
    console.log("detialType", this.detialType);
    this.getSizeListData();
    this.getPackageType();
    this.$dictionary.get(['CARGO_GROUP'], true).then(function (res) {
      res = JSON.parse(JSON.stringify(res));
      var array = res.CARGO_GROUP ? res.CARGO_GROUP : [];
      var list = [];
      if (array.length > 0) {
        array.map(function (item, index) {
          list.push({
            value: item.codeValue,
            label: item.displayValue
          });
        });
      }
      _this3.cargoGroupList = list;
    });
    if (this.detialType == 'New') {
      this.addFormData = this.$route.query.addFormData;
      this.isTableItemTsFlag = this.addFormData.searrcForm.tsFlag;
      if (this.addFormData.searrcForm.tsFlag == '0') {
        this.voyagesData = this.addFormData.tabledata;
        this.webBookingHead.por = this.addFormData.searrcForm.pol;
        this.webBookingHead.pol = this.addFormData.searrcForm.pol;
        this.webBookingHead.pod = this.addFormData.searrcForm.pod;
        this.webBookingHead.del = this.addFormData.searrcForm.pod;
        this.polNameList.porName = this.addFormData.searrcForm.polName;
        this.polNameList.polName = this.addFormData.searrcForm.polName;
        this.polNameList.podName = this.addFormData.searrcForm.podName;
        this.polNameList.delName1 = this.addFormData.searrcForm.podName;
      } else {
        this.getMulitVoyageData(this.addFormData.tabledata);
        var voyagesMainData = this.voyagesData.filter(function (item) {
          return item.lineType === '1';
        });
        this.webBookingHead.por = this.voyagesData.filter(function (item) {
          return item.tripNumber === '1';
        })[0].polHidden;
        this.webBookingHead.pol = voyagesMainData[0].polHidden;
        this.webBookingHead.pod = voyagesMainData[voyagesMainData.length - 1].podHidden;
        this.webBookingHead.del = this.voyagesData[this.voyagesData.length - 1].podHidden;
        this.getPortName(this.voyagesData.filter(function (item) {
          return item.tripNumber === '1';
        })[0].polHidden).then(function (res) {
          _this3.polNameList.porName = res;
        });
        this.getPortName(voyagesMainData[0].polHidden).then(function (res) {
          _this3.polNameList.polName = res;
        });
        this.getPortName(voyagesMainData[voyagesMainData.length - 1].podHidden).then(function (res) {
          _this3.polNameList.podName = res;
        });
        this.getPortName(this.voyagesData[this.voyagesData.length - 1].podHidden).then(function (res) {
          _this3.polNameList.delName1 = res;
        });
      }
      console.log('this.voyagesData', this.voyagesData);
      console.log('this.addFormData.searrcForm', this.addFormData.searrcForm);
      // await this.getPortName(res.data.pol)

      // this.webBookingHead.transportationTerms='CY-CY'
      // this.webBookingHead.bookingType=1
      // this.webBookingHead.tsFlag='0'
      console.log('    this.webBookingHead', this.webBookingHead);
    } else {
      // voyageData:解决用对象传参导致的刷新显示不正确问题
      this.voyagesData = (0, _validate.validateNull)(this.$route.query.voyageData) ? [] : JSON.parse(this.$route.query.voyageData);
      console.log('++++++++++++ this.voyagesData', this.voyagesData);
      this.detailsId = this.$route.query.id;
      this.getDetailFormData();
    }
    console.log(' this.detialType', this.detialType);
    console.log(' this.detailsId', this.detailsId);
  },
  mounted: function mounted() {
    this.autoTrWidth = this.$refs.tableAutoRef.offsetWidth;
  },
  methods: {
    validateNull: _validate.validateNull,
    getOpenPaegContact: function getOpenPaegContact() {
      var _this$$router$resolve = this.$router.resolve({
          path: '/containerTypeDetail'
        }),
        href = _this$$router$resolve.href;
      window.open(href, '_blank');
    },
    getOpenPaegDgList: function getOpenPaegDgList() {
      var _this$$router$resolve2 = this.$router.resolve({
          path: '/bookingJapanDgList'
        }),
        href = _this$$router$resolve2.href;
      window.open(href, '_blank');
    },
    getMulitVoyageData: function getMulitVoyageData(voyageData) {
      for (var i = 0; i < voyageData.length; i++) {
        console.log('voyageData', voyageData[i]);
        var carrierList = [];
        var etdList = [];
        var etaList = [];
        var lineTypeList = [];
        var podHiddenist = [];
        var polEtaList = [];
        var polEtaHiddenList = [];
        var polHiddenList = [];
        var serviceLineCodeList = [];
        var tripNumberList = [];
        var vesselCodeList = [];
        var vesselNameList = [];
        var vesselNameCnList = [];
        var voyageLegList = [];
        var voyageNoList = [];

        // portFromEta、portFromEtd、portToEta

        if (voyageData[i].vesselNameCn) {
          vesselNameCnList = voyageData[i].vesselNameCn.split('\n');
        }
        carrierList = voyageData[i].carrier.split('\n');
        etdList = voyageData[i].etd.split('\n');
        etaList = voyageData[i].eta.split('\n');
        polEtaHiddenList = voyageData[i].polEtaHidden.split('\n');
        lineTypeList = voyageData[i].lineType.split('\n');
        podHiddenist = voyageData[i].podHidden.split('\n');
        polEtaList = voyageData[i].polEta.split('\n');
        polHiddenList = voyageData[i].polHidden.split('\n');
        serviceLineCodeList = voyageData[i].serviceLineCode.split('\n');
        tripNumberList = voyageData[i].tripNumber.split('\n');
        vesselCodeList = voyageData[i].vesselCode.split('\n');
        vesselNameList = voyageData[i].vesselName.split('\n');
        voyageLegList = voyageData[i].voyageLeg.split('\n');
        voyageNoList = voyageData[i].voyageNo.split('\n');
        for (var j = 0; j < vesselNameList.length; j++) {
          console.log('etdList[j]', etdList[j]);
          var carrier = '';
          var eta = '';
          var etd = '';
          var lineType = '';
          var podHidden = '';
          var polEta = '';
          var polEtaHidden = '';
          var polHidden = '';
          var serviceLineCode = '';
          var tripNumber = '';
          var vesselCode = '';
          var vesselName = '';
          var vesselNameCn = '';
          var voyageLeg = '';
          var voyageNo = '';
          if (carrierList[j] !== '-') {
            carrier = carrierList[j];
          }
          if (etaList[j] !== '-') {
            eta = etaList[j];
          }
          if (etdList[j] !== '-') {
            etd = etdList[j];
          }
          if (lineTypeList[j] !== '-') {
            lineType = lineTypeList[j];
          }
          if (podHiddenist[j] !== '-') {
            podHidden = podHiddenist[j];
          }
          if (polEtaList[j] !== '-') {
            polEta = polEtaList[j];
          }
          if (polEtaHiddenList[j] !== '-') {
            polEtaHidden = polEtaHiddenList[j];
          }
          if (polHiddenList[j] !== '-') {
            polHidden = polHiddenList[j];
          }
          if (serviceLineCodeList[j] !== '-') {
            serviceLineCode = serviceLineCodeList[j];
          }
          if (tripNumberList[j] !== '-') {
            tripNumber = tripNumberList[j];
          }
          if (vesselCodeList[j] !== '-') {
            vesselCode = vesselCodeList[j];
          }
          if (vesselNameList[j] !== '-') {
            vesselName = vesselNameList[j];
          }
          if (vesselNameCnList[j] !== '-') {
            vesselNameCn = vesselNameCnList[j];
          }
          if (voyageLegList[j] !== '-') {
            voyageLeg = voyageLegList[j];
          }
          if (voyageNoList[j] !== '-') {
            voyageNo = voyageNoList[j];
          }
          this.voyagesData.push({
            carrier: carrier,
            eta: eta,
            etd: etd,
            lineType: lineType,
            podHidden: podHidden,
            polEta: polEta,
            polEtaHidden: polEtaHidden,
            polHidden: polHidden,
            serviceLineCode: serviceLineCode,
            tripNumber: tripNumber,
            vesselCode: vesselCode,
            vesselName: vesselName,
            vesselNameCn: vesselNameCn,
            voyageLeg: voyageLeg,
            voyageNo: voyageNo
          });
        }
        console.log('this.voyagesData', this.voyagesData);
      }
    },
    closeDialog: function closeDialog() {
      this.sailScheduleDialogVisible = false;
    },
    selectionChangeSailSchedule: function selectionChangeSailSchedule(row) {
      var _this4 = this;
      this.isTableItemTsFlag = row.searrcForm.tsFlag;
      if (row.searrcForm.tsFlag === '0') {
        var listData = row.tabledata;
        console.log('row', row);
        var array = [];
        listData.map(function (item, index) {
          array.push({
            rowStatus: 4,
            vesselName: item.vesselName,
            voyageNo: item.voyageNo,
            voyageLeg: item.voyageLeg,
            polEtaHidden: item.polEtaHidden,
            polEta: item.polEta,
            etd: item.etd,
            eta: item.eta,
            vesselCode: item.vesselCode,
            vesselNameCn: item.vesselNameCn,
            serviceLineCode: item.serviceLineCode,
            lineType: item.lineType,
            tripNumber: item.tripNumber,
            carrier: item.carrier,
            polHidden: item.polHidden,
            podHidden: item.podHidden
          });
        });
        this.voyagesData = array;
        this.webBookingHead.por = this.voyagesData[0].polHidden;
        this.webBookingHead.pol = this.voyagesData[0].polHidden;
        this.webBookingHead.pod = this.voyagesData[0].podHidden;
        this.webBookingHead.del = this.voyagesData[0].podHidden;
        this.getPortName(this.voyagesData[0].polHidden).then(function (res) {
          _this4.polNameList.porName = res;
        });
        this.getPortName(this.voyagesData[0].polHidden).then(function (res) {
          _this4.polNameList.polName = res;
        });
        this.getPortName(this.voyagesData[0].podHidden).then(function (res) {
          _this4.polNameList.podName = res;
        });
        this.getPortName(this.voyagesData[0].podHidden).then(function (res) {
          _this4.polNameList.delName1 = res;
        });
      } else {
        this.getMulitVoyageData(row.tabledata);
        var voyagesMainData = this.voyagesData.filter(function (item) {
          return item.lineType === '1';
        });
        this.webBookingHead.por = this.voyagesData.filter(function (item) {
          return item.tripNumber === '1';
        })[0].polHidden;
        this.webBookingHead.pol = voyagesMainData[0].polHidden;
        this.webBookingHead.pod = voyagesMainData[voyagesMainData.length - 1].podHidden;
        this.webBookingHead.del = this.voyagesData[this.voyagesData.length - 1].podHidden;
        this.getPortName(this.voyagesData.filter(function (item) {
          return item.tripNumber === '1';
        })[0].polHidden).then(function (res) {
          _this4.polNameList.porName = res;
        });
        this.getPortName(voyagesMainData[0].polHidden).then(function (res) {
          _this4.polNameList.polName = res;
        });
        this.getPortName(voyagesMainData[voyagesMainData.length - 1].podHidden).then(function (res) {
          _this4.polNameList.podName = res;
        });
        this.getPortName(this.voyagesData[this.voyagesData.length - 1].podHidden).then(function (res) {
          _this4.polNameList.delName1 = res;
        });
      }
      console.log(' this.voyagesData', this.voyagesData);
      this.isOtherVoyage = true;
      this.sailScheduleDialogVisible = false;
    },
    dangerCheckboxChange: function dangerCheckboxChange() {
      var _this5 = this;
      console.log('this.webBookingHead.dgCheckFlag', this.webBookingHead.dgCheckFlag);
      if (this.webBookingHead.dgCheckFlag == 0 && !(0, _validate.validateNull)(this.webBookingHead.webBkCargos[0].webBkImos)) {
        this.webBookingHead.webBkCargos[0].webBkImos.length && this.webBookingHead.webBkCargos[0].webBkImos.forEach(function (item) {
          if (item.bkImoWebId) {
            item.rowStatus = 8;
            _this5.webBookingHead.deleteWebBkImos.push(item);
          }
        });
        this.webBookingHead.webBkCargos[0].webBkImos = [];
      }
    },
    reeferCheckboxChange: function reeferCheckboxChange() {
      var _this6 = this;
      if (this.webBookingHead.rfCheckFlag == 0 && !(0, _validate.validateNull)(this.webBookingHead.webBkCargos[0].webBkReefers)) {
        this.webBookingHead.webBkCargos[0].webBkReefers.length && this.webBookingHead.webBkCargos[0].webBkReefers.forEach(function (item) {
          if (item.bkReeferWebId) {
            item.rowStatus = 8;
            _this6.webBookingHead.deleteWebBkReefers.push(item);
          }
        });
        this.webBookingHead.webBkCargos[0].webBkReefers = [];
      }
    },
    akCheckboxChange: function akCheckboxChange() {
      var _this7 = this;
      if (this.webBookingHead.akCheckFlag == 0 && !(0, _validate.validateNull)(this.webBookingHead.webBkAks)) {
        this.webBookingHead.webBkAks.length && this.webBookingHead.webBkAks.forEach(function (item) {
          if (item.bkAkWebId) {
            item.rowStatus = 8;
            _this7.webBookingHead.deleteWebBkAks.push(item);
          }
          _this7.webBookingHead.webBkAks = [];
        });
      }
    },
    delRadioChange: function delRadioChange() {
      this.polNameList.delName = '';
      console.log('this.webBookingHead.tsFlag', this.webBookingHead.tsFlag);
    },
    addWebBkPreContainers: function addWebBkPreContainers() {
      this.webBookingHead.webBkPreContainers.push({
        commodityCode: "",
        containerType: "",
        quantity: "",
        rowStatus: 4
      });
    },
    addWebBkReefers: function addWebBkReefers() {
      this.webBookingHead.webBkCargos[0].webBkReefers.push({
        rowStatus: 4,
        rateBase: 'C',
        temperature: '',
        preCool: '',
        intakeNum: ''
      });
    },
    addWebBkAks: function addWebBkAks() {
      this.webBookingHead.webBkAks.push({
        rowStatus: 4,
        containerType: '',
        akLength: '',
        akWidth: '',
        akHigth: '',
        akGrossWeight: ''
      });
    },
    addWebBkImos: function addWebBkImos() {
      this.deleteIndexWebBkImos = -1;
      this.webBookingHead.webBkCargos[0].webBkImos.push({
        rowStatus: 4,
        classType: '',
        unSeriseNo: '',
        quantity: '',
        packageDesc: '',
        packageCode: '',
        grossWeight: '',
        netWeight: '',
        flashPoint: null,
        casNo1: '',
        casNo2: '',
        casNo3: '',
        cargoSize: '',
        temperature: '',
        intakeNum: '',
        contactName: '',
        contactNumber: '',
        contactTypeCode: '',
        approveKey: '',
        componentDesc: '',
        property: '',
        emergencyTelNo: ''
      });
    },
    cellClassNameWebBkAks: function cellClassNameWebBkAks(_ref) {
      var row = _ref.row,
        column = _ref.column,
        rowIndex = _ref.rowIndex,
        columnIndex = _ref.columnIndex;
      row.index = rowIndex;
      column.index = columnIndex;
    },
    cellClassNameWebBkImos: function cellClassNameWebBkImos(_ref2) {
      var row = _ref2.row,
        column = _ref2.column,
        rowIndex = _ref2.rowIndex,
        columnIndex = _ref2.columnIndex;
      row.index = rowIndex;
      column.index = columnIndex;
    },
    cellClassNameWebBkReefers: function cellClassNameWebBkReefers(_ref3) {
      var row = _ref3.row,
        column = _ref3.column,
        rowIndex = _ref3.rowIndex,
        columnIndex = _ref3.columnIndex;
      row.index = rowIndex;
      column.index = columnIndex;
    },
    cellClassNameWebBkPreContainers: function cellClassNameWebBkPreContainers(_ref4) {
      var row = _ref4.row,
        column = _ref4.column,
        rowIndex = _ref4.rowIndex,
        columnIndex = _ref4.columnIndex;
      row.index = rowIndex;
      column.index = columnIndex;
    },
    deleteWebBkPreContainers: function deleteWebBkPreContainers() {
      if (this.deleteIndexWebBkPreContainers >= 0 && this.webBookingHead.webBkPreContainers.length > 1) {
        if (this.webBookingHead.webBkPreContainers[this.deleteIndexWebBkPreContainers].bkPreContainerWebId) {
          this.webBookingHead.webBkPreContainers[this.deleteIndexWebBkPreContainers].rowStatus = 8;
          this.webBookingHead.deleteWebBkPreContainers.push(this.webBookingHead.webBkPreContainers[this.deleteIndexWebBkPreContainers]);
        }
        this.webBookingHead.webBkPreContainers.splice(this.deleteIndexWebBkPreContainers, 1);
      }
    },
    deleteWebBkReefers: function deleteWebBkReefers() {
      if (this.deleteIndexWebBkReefers >= 0 && this.webBookingHead.webBkCargos[0].webBkReefers.length > 1) {
        if (this.webBookingHead.webBkCargos[0].webBkReefers[this.deleteIndexWebBkReefers].bkReeferWebId) {
          this.webBookingHead.webBkCargos[0].webBkReefers[this.deleteIndexWebBkReefers].rowStatus = 8;
          this.webBookingHead.deleteWebBkReefers.push(this.webBookingHead.webBkCargos[0].webBkReefers[this.deleteIndexWebBkReefers]);
        }
        this.webBookingHead.webBkCargos[0].webBkReefers.splice(this.deleteIndexWebBkReefers, 1);
      }
    },
    deleteWebBkAks: function deleteWebBkAks() {
      if (this.deleteIndexWebBkAks >= 0 && this.webBookingHead.webBkAks.length > 1) {
        if (this.webBookingHead.webBkAks[this.deleteIndexWebBkAks].bkAkWebId) {
          this.webBookingHead.webBkAks[this.deleteIndexWebBkAks].rowStatus = 8;
          this.webBookingHead.deleteWebBkAks.push(this.webBookingHead.webBkAks[this.deleteIndexWebBkAks]);
        }
        this.webBookingHead.webBkAks.splice(this.deleteIndexWebBkAks, 1);
      }
    },
    deleteWebBkImos: function deleteWebBkImos() {
      if (this.deleteIndexWebBkImos >= 0 && this.webBookingHead.webBkCargos[0].webBkImos.length > 1) {
        if (this.webBookingHead.webBkCargos[0].webBkImos[this.deleteIndexWebBkImos].bkImoWebId) {
          this.webBookingHead.webBkCargos[0].webBkImos[this.deleteIndexWebBkImos].rowStatus = 8;
          this.webBookingHead.deleteWebBkImos.push(this.webBookingHead.webBkCargos[0].webBkImos[this.deleteIndexWebBkImos]);
        }
        this.webBookingHead.webBkCargos[0].webBkImos.splice(this.deleteIndexWebBkImos, 1);
      }
    },
    cellClickWebBkAks: function cellClickWebBkAks(row, column) {
      console.log('rowCLick row, column', row, column);
      this.deleteIndexWebBkAks = row.index;
    },
    cellClickWebBkImos: function cellClickWebBkImos(row, column) {
      console.log('rowCLick row, column', row, column);
      this.deleteIndexWebBkImos = row.index;
    },
    cellClickWebBkReefers: function cellClickWebBkReefers(row, column) {
      console.log('rowCLick row, column', row, column);
      this.deleteIndexWebBkReefers = row.index;
    },
    cellClickWebBkPreContainers: function cellClickWebBkPreContainers(row, column) {
      console.log('rowCLick row, column', row, column);
      this.deleteIndexWebBkPreContainers = row.index;
    },
    getPackageType: function getPackageType() {
      var _this8 = this;
      (0, _booking.getQueryListCodeName)('PACKAGE_TYPE').then(function (res) {
        _this8.packageTypeList = res.data;
      });
    },
    getSizeListData: function getSizeListData() {
      var _this9 = this;
      var data = {
        pageSize: 1000,
        currentPage: 1
      };
      (0, _booking.queryListCode)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, data), {}, {
        type: "EQUIPMENT"
      })).then(function (res) {
        _this9.sizeList = res.data;
      });
    },
    getCustomerData: function getCustomerData(keyword) {
      console.log('keyword', keyword);
      var data = {};
      data.currentPage = 1;
      data.pageSize = 20;
      if (keyword !== '') {
        data.customerCode = keyword;
        data.customerNameCn = '';
        data.customerName = '';
        data.taxRegisterNo = '';
      }
      if (data.customerCode) {
        data.customerCode = '%' + data.customerCode + '%';
      }
      // if (data.customerNameCn) {
      //   data.customerNameCn = '%' + data.customerNameCn + '%'
      // }
      // if (data.customerName) {
      //   data.customerName = '%' + data.customerName + '%'
      // }
      // if (data.taxRegisterNo) {
      //   data.taxRegisterNo = '%' + data.taxRegisterNo + '%'
      // }
      (0, _booking.queryListSimisCustomer)(data).then(function (res) {
        console.log('res', res);
      });
    },
    // 打印数据
    customerSelectChange: function customerSelectChange(data, value) {
      console.log('+++++++++++data,value', data, value);
    },
    formatDate: function formatDate() {
      var date = new Date();
      var year = date.getFullYear();
      var month = ('0' + (date.getMonth() + 1)).slice(-2);
      var day = ('0' + date.getDate()).slice(-2);
      var hours = ('0' + date.getHours()).slice(-2);
      var minutes = ('0' + date.getMinutes()).slice(-2);
      var seconds = ('0' + date.getSeconds()).slice(-2);
      return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
    },
    backJpBookingHistory: function backJpBookingHistory() {
      this.$router.push('/bookingSpace/bookingHistoryJp');
    },
    handleSetDeleteData: function handleSetDeleteData() {
      // 下货纸
      this.webBookingHead.webBkPreContainers = [].concat((0, _toConsumableArray2.default)(this.webBookingHead.webBkPreContainers), (0, _toConsumableArray2.default)(this.webBookingHead.deleteWebBkPreContainers));
      delete this.webBookingHead.deleteWebBkPreContainers;
      // 危险品
      this.webBookingHead.webBkCargos[0].webBkImos = [].concat((0, _toConsumableArray2.default)(this.webBookingHead.webBkCargos[0].webBkImos), (0, _toConsumableArray2.default)(this.webBookingHead.deleteWebBkImos));
      delete this.webBookingHead.deleteWebBkImos;
      // 冷箱
      this.webBookingHead.webBkCargos[0].webBkReefers = [].concat((0, _toConsumableArray2.default)(this.webBookingHead.webBkCargos[0].webBkReefers), (0, _toConsumableArray2.default)(this.webBookingHead.deleteWebBkReefers));
      delete this.webBookingHead.deleteWebBkReefers;
      // 特种箱
      this.webBookingHead.webBkAks = [].concat((0, _toConsumableArray2.default)(this.webBookingHead.webBkAks), (0, _toConsumableArray2.default)(this.webBookingHead.deleteWebBkAks));
      delete this.webBookingHead.deleteWebBkAks;
    },
    // 保存按钮
    SaveAndChangeSubmit: function SaveAndChangeSubmit() {
      var _this10 = this;
      //传真已勾选不能为空
      if ((0, _validate.validateNull)(this.webBookingHead.webBkExtends[0].brokerFax) && this.webBookingHead.webBkExtends[0].isSendBrokerFax === 1) {
        this.$message({
          message: this.$t('booking.bookingHistroryJpDetails.faxNotNull'),
          dangerouslyUseHTMLString: true,
          type: 'warning'
        });
        return;
      }
      //已勾选不能为空且对邮箱长度和规则校验
      if ((0, _validate.validateNull)(this.webBookingHead.webBkExtends[0].brokerEmail)) {
        if (this.webBookingHead.webBkExtends[0].isSendBrokerEmail === 1) {
          this.$message({
            message: this.$t('blExchangeAppointment.emailNotNull'),
            dangerouslyUseHTMLString: true,
            type: 'warning'
          });
          return;
        }
      } else {
        if (this.webBookingHead.webBkExtends[0].brokerEmail.length > 500) {
          this.$message({
            message: this.$t('userCenter.userInfo.emailCheckRules1'),
            dangerouslyUseHTMLString: true,
            type: 'warning'
          });
          return;
        }
        var array = this.webBookingHead.webBkExtends[0].brokerEmail.split(";");
        for (var i = 0; i < array.length; i++) {
          if (!/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(array[i])) {
            this.$message({
              message: this.$t('userCenter.userInfo.emailCheckRules2'),
              dangerouslyUseHTMLString: true,
              type: 'warning'
            });
            return;
          }
        }
      }
      if (!this.webBookingHead.webBkExtends[0].customsBroker) {
        this.$message({
          message: this.$t('booking.bookingHistroyJp.customsBrokerWarning'),
          dangerouslyUseHTMLString: true,
          type: 'warning'
        });
        return;
      }
      if (!this.webBookingHead.webBkPreContainers[0].containerType || !this.webBookingHead.webBkPreContainers[0].quantity || !this.webBookingHead.webBkPreContainers[0].commodityCode) {
        this.$message({
          message: this.$t('booking.bookingHistroyJp.commodityCodeWaring'),
          dangerouslyUseHTMLString: true,
          type: 'warning'
        });
        return;
      }
      if (!this.webBookingHead.webBkCargos[0].grossWeight) {
        this.$message({
          message: this.$t('booking.bookingHistroyJp.grossWeightWarning'),
          dangerouslyUseHTMLString: true,
          type: 'warning'
        });
        return;
      }
      if (!this.webBookingHead.webBkCargos[0].cargoDesc) {
        this.$message({
          message: this.$t('booking.bookingHistroyJp.cargoDescWarnng'),
          dangerouslyUseHTMLString: true,
          type: 'warning'
        });
        return;
      }
      if (this.detialType == 'Preview') {
        this.webBookingHead.webBkCargos[0].webBkImos[0].emergencyTelNo = this.emergencyTelNoData[0].emergencyTelNo;
        this.webBookingHead.deliveryDocumentCompany = this.deliveryDocumentCompany;
      }
      if (this.webBookingHead.dgCheckFlag == '1') {
        for (var _i = 0; _i < this.webBookingHead.webBkCargos.length; _i++) {
          this.webBookingHead.webBkCargos[0].webBkImos[_i].emergencyTelNo = this.emergencyTelNoData[0].emergencyTelNo;
          if (this.webBookingHead.webBkCargos[0].webBkImos[_i].classType == '' || this.webBookingHead.webBkCargos[0].webBkImos[_i].unSeriseNo == '' || this.webBookingHead.webBkCargos[0].webBkImos[_i].quantity == '' || this.webBookingHead.webBkCargos[0].webBkImos[_i].packageDesc == '' || this.webBookingHead.webBkCargos[0].webBkImos[_i].packageCode == '' || this.webBookingHead.webBkCargos[0].webBkImos[_i].grossWeight == '' || this.webBookingHead.webBkCargos[0].webBkImos[_i].netWeight == '' || this.webBookingHead.webBkCargos[0].webBkImos[_i].casNo1 == '' || this.webBookingHead.webBkCargos[0].webBkImos[_i].casNo2 == '' || this.webBookingHead.webBkCargos[0].webBkImos[_i].casNo3 == '' || this.webBookingHead.webBkCargos[0].webBkImos[_i].cargoSize == '' || this.webBookingHead.webBkCargos[0].webBkImos[_i].contactName == '' || this.webBookingHead.webBkCargos[0].webBkImos[_i].contactNumber == '' || this.webBookingHead.webBkCargos[0].webBkImos[_i].contactTypeCode == '' || this.webBookingHead.webBkCargos[0].webBkImos[_i].componentDesc == '' || this.webBookingHead.webBkCargos[0].webBkImos[_i].property == '' || this.webBookingHead.webBkCargos[0].webBkImos[_i].emergencyTelNo == '') {
            console.log('this.emergencyTelNoData[0].emergencyTelNo', this.emergencyTelNoData[0].emergencyTelNo);
            console.log('this.webBookingHead.webBkCargos[0].webBkImos[i]', this.webBookingHead.webBkCargos[0].webBkImos[_i]);
            this.$message({
              message: this.$t('booking.bookingHistroyJp.webBkImosWarning'),
              dangerouslyUseHTMLString: true,
              type: 'warning'
            });
            return;
          }
        }
      }
      if (this.webBookingHead.rfCheckFlag == '1' && (0, _validate.validateNull)(this.webBookingHead.webBkCargos[0].webBkReefers)) {
        this.$message({
          message: this.$t('booking.bookingHistroyJp.webBkReefersWarning'),
          dangerouslyUseHTMLString: true,
          type: 'warning'
        });
        return;
      }
      if (this.webBookingHead.akCheckFlag == '1') {
        for (var _i2 = 0; _i2 < this.webBookingHead.webBkAks.length; _i2++) {
          if (this.webBookingHead.webBkAks[_i2].containerType == '' || this.webBookingHead.webBkAks[_i2].akLength == '' || this.webBookingHead.webBkAks[_i2].akWidth == '' || this.webBookingHead.webBkAks[_i2].akHigth == '' || this.webBookingHead.webBkAks[_i2].akGrossWeight == '') {
            this.$message({
              message: this.$t('booking.bookingHistroyJp.webBkAksWarning'),
              dangerouslyUseHTMLString: true,
              type: 'warning'
            });
            return;
          }
        }
      }
      if (this.webBookingHead.deliveryDocumentMethod == 2) {
        if (this.deliveryDocumentCompany == '') {
          this.$message({
            message: this.$t('booking.bookingHistroyJp.deliveryDocumentCompanyWarning'),
            dangerouslyUseHTMLString: true,
            type: 'warning'
          });
          return;
        }
      }
      this.webBookingHead.deliveryDocumentCompany = this.deliveryDocumentCompany;

      // if(this.webBookingHead.tsFlag===1){
      //   this.webBookingHead.del=this.polNameList.delName
      // }

      //  拷贝时
      console.log('this.webBookingHead', this.webBookingHead);
      if (this.detialType == 'Copy') {
        if ((0, _validate.validateNull)(this.voyagesData)) {
          this.$message({
            message: this.$t('surveyApply.message.checkVVL'),
            dangerouslyUseHTMLString: true,
            type: 'warning'
          });
          return;
        }
        this.webBookingHead.bookingHeadWebId = null;
        this.webBookingHead.rowStatus = 10;
      }
      if (this.detialType == 'New') {
        this.webBookingHead.remark = this.webBookingHead.remarkFromOutbound;
      }
      // bookingHeadWebId

      var params = {
        voyages: this.voyagesData,
        webBookingHead: this.webBookingHead
      };
      if (this.detialType == 'Change') {
        this.loading = (0, _utils.load)();
        this.handleSetDeleteData();
        this.webBookingHead.rowStatus = 16;
        (0, _bookingHistoryJp.saveOrUpdateBookingHeadWeb)(this.webBookingHead).then(function (res) {
          // this.$message({
          //   message: this.$t('booking.bookingHistroryJpDetails.submit'),
          //   type: 'success'
          // })
          // if(this.webBookingHead.status!=='10'){
          //  this.$router.push('/bookingSpace/bookingHistoryJp')
          // }
          _this10.saveFormId = res.data.bookingHeadWebId;
          _this10.detailsId = _this10.saveFormId;
          _this10.getDetailFormData();
          _this10.loading.close();
          _this10.showSave = false;
          _this10.showSubmit = true;
        }).catch(function (err) {});
      } else {
        if (this.isTableItemTsFlag == '0') {
          console.log('直达');
          (0, _bookingHistoryJp.saveOrUpdateByVoyage)(params).then(function (res) {
            // this.$message({
            //   message: this.$t('booking.bookingHistroryJpDetails.submit'),
            //   type: 'success'
            // })

            _this10.saveFormId = res.data[0];
            _this10.showSave = false;
            _this10.showSubmit = true;
          }).catch(function (err) {});
        } else {
          console.log('中转');
          (0, _bookingHistoryJp.saveOrUpdateByTsVoyage)(params).then(function (res) {
            // this.$message({
            //   message: this.$t('booking.bookingHistroryJpDetails.saveSuccess'),
            //   type: 'success'
            // })

            _this10.saveFormId = res.data[0];
            _this10.showSave = false;
            _this10.showSubmit = true;
          }).catch(function (err) {});
        }
      }
    },
    submitForm: function submitForm() {
      var _this11 = this;
      (0, _bookingHistoryJp.saveApplyBookingHeadWebs)([this.saveFormId]).then(function (res) {
        _this11.$message({
          message: _this11.$t('booking.bookingHistroryJpDetails.submitSuccess'),
          type: 'success'
        });
        _this11.delTag();
        _this11.$router.push('/bookingSpace/bookingHistoryJp');
      }).catch(function (err) {});
    },
    // 保存草稿按钮
    saveFormData: function saveFormData() {
      var _this12 = this;
      //已勾选不能为空且对邮箱长度和规则校验
      if ((0, _validate.validateNull)(this.webBookingHead.webBkExtends[0].brokerEmail)) {
        if (this.webBookingHead.webBkExtends[0].isSendBrokerEmail === 1) {
          this.$message({
            message: this.$t('blExchangeAppointment.emailNotNull'),
            dangerouslyUseHTMLString: true,
            type: 'warning'
          });
          return;
        }
      } else {
        if (this.webBookingHead.webBkExtends[0].brokerEmail.length > 500) {
          this.$message({
            message: this.$t('userCenter.userInfo.emailCheckRules1'),
            dangerouslyUseHTMLString: true,
            type: 'warning'
          });
          return;
        }
        var array = this.webBookingHead.webBkExtends[0].brokerEmail.split(";");
        for (var i = 0; i < array.length; i++) {
          if (!/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(array[i])) {
            this.$message({
              message: this.$t('userCenter.userInfo.emailCheckRules2'),
              dangerouslyUseHTMLString: true,
              type: 'warning'
            });
            return;
          }
        }
      }
      if (!this.webBookingHead.webBkExtends[0].customsBroker) {
        this.$message({
          message: this.$t('booking.bookingHistroyJp.customsBrokerWarning'),
          dangerouslyUseHTMLString: true,
          type: 'warning'
        });
        return;
      }
      if (!this.webBookingHead.webBkPreContainers[0].containerType || !this.webBookingHead.webBkPreContainers[0].quantity || !this.webBookingHead.webBkPreContainers[0].commodityCode) {
        this.$message({
          message: this.$t('booking.bookingHistroyJp.commodityCodeWaring'),
          dangerouslyUseHTMLString: true,
          type: 'warning'
        });
        return;
      }
      if (!this.webBookingHead.webBkCargos[0].grossWeight) {
        this.$message({
          message: this.$t('booking.bookingHistroyJp.grossWeightWarning'),
          dangerouslyUseHTMLString: true,
          type: 'warning'
        });
        return;
      }
      if (!this.webBookingHead.webBkCargos[0].cargoDesc) {
        this.$message({
          message: this.$t('booking.bookingHistroyJp.cargoDescWarnng'),
          dangerouslyUseHTMLString: true,
          type: 'warning'
        });
        return;
      }
      if (this.detialType == 'Preview') {
        this.webBookingHead.webBkCargos[0].webBkImos[0].emergencyTelNo = this.emergencyTelNoData[0].emergencyTelNo;
        this.webBookingHead.deliveryDocumentCompany = this.deliveryDocumentCompany;
      }
      if (this.webBookingHead.dgCheckFlag == '1') {
        for (var _i3 = 0; _i3 < this.webBookingHead.webBkCargos.length; _i3++) {
          this.webBookingHead.webBkCargos[0].webBkImos[_i3].emergencyTelNo = this.emergencyTelNoData[0].emergencyTelNo;
          if (this.webBookingHead.webBkCargos[0].webBkImos[_i3].classType == '' || this.webBookingHead.webBkCargos[0].webBkImos[_i3].unSeriseNo == '' || this.webBookingHead.webBkCargos[0].webBkImos[_i3].quantity == '' || this.webBookingHead.webBkCargos[0].webBkImos[_i3].packageDesc == '' || this.webBookingHead.webBkCargos[0].webBkImos[_i3].packageCode == '' || this.webBookingHead.webBkCargos[0].webBkImos[_i3].grossWeight == '' || this.webBookingHead.webBkCargos[0].webBkImos[_i3].netWeight == '' || this.webBookingHead.webBkCargos[0].webBkImos[_i3].casNo1 == '' || this.webBookingHead.webBkCargos[0].webBkImos[_i3].casNo2 == '' || this.webBookingHead.webBkCargos[0].webBkImos[_i3].casNo3 == '' || this.webBookingHead.webBkCargos[0].webBkImos[_i3].cargoSize == '' || this.webBookingHead.webBkCargos[0].webBkImos[_i3].contactName == '' || this.webBookingHead.webBkCargos[0].webBkImos[_i3].contactNumber == '' || this.webBookingHead.webBkCargos[0].webBkImos[_i3].contactTypeCode == '' || this.webBookingHead.webBkCargos[0].webBkImos[_i3].componentDesc == '' || this.webBookingHead.webBkCargos[0].webBkImos[_i3].property == '' || this.webBookingHead.webBkCargos[0].webBkImos[_i3].emergencyTelNo == '') {
            console.log('this.emergencyTelNoData[0].emergencyTelNo', this.emergencyTelNoData[0].emergencyTelNo);
            console.log('this.webBookingHead.webBkCargos[0].webBkImos[i]', this.webBookingHead.webBkCargos[0].webBkImos[_i3]);
            this.$message({
              message: this.$t('booking.bookingHistroyJp.webBkImosWarning'),
              dangerouslyUseHTMLString: true,
              type: 'warning'
            });
            return;
          }
        }
      }
      if (this.webBookingHead.rfCheckFlag == '1' && (0, _validate.validateNull)(this.webBookingHead.webBkCargos[0].webBkReefers)) {
        this.$message({
          message: this.$t('booking.bookingHistroyJp.webBkReefersWarning'),
          dangerouslyUseHTMLString: true,
          type: 'warning'
        });
        return;
      }
      if (this.webBookingHead.akCheckFlag == '1') {
        for (var _i4 = 0; _i4 < this.webBookingHead.webBkAks.length; _i4++) {
          if (this.webBookingHead.webBkAks[_i4].containerType == '' || this.webBookingHead.webBkAks[_i4].akLength == '' || this.webBookingHead.webBkAks[_i4].akWidth == '' || this.webBookingHead.webBkAks[_i4].akHigth == '' || this.webBookingHead.webBkAks[_i4].akGrossWeight == '') {
            this.$message({
              message: this.$t('booking.bookingHistroyJp.webBkAksWarning'),
              dangerouslyUseHTMLString: true,
              type: 'warning'
            });
            return;
          }
        }
      }
      if (this.webBookingHead.deliveryDocumentMethod == 2) {
        if (this.deliveryDocumentCompany == '') {
          this.$message({
            message: this.$t('booking.bookingHistroyJp.deliveryDocumentCompanyWarning'),
            dangerouslyUseHTMLString: true,
            type: 'warning'
          });
          return;
        }
      }
      if (this.webBookingHead.webBkCargos.length > 0) {
        if (this.webBookingHead.webBkCargos[0].webBkImos.length > 0) {
          this.webBookingHead.webBkCargos[0].webBkImos[0].emergencyTelNo = this.emergencyTelNoData[0].emergencyTelNo;
        }
      }
      // this.webBookingHead.webBkCargos[0].webBkImos[0].emergencyTelNo=this.emergencyTelNoData[0].emergencyTelNo

      this.webBookingHead.deliveryDocumentCompany = this.deliveryDocumentCompany;

      // if(this.webBookingHead.tsFlag===1){
      //   this.webBookingHead.del=this.polNameList.delName
      // }

      console.log('this.webBookingHead', this.webBookingHead);
      if (this.detialType == 'Copy') {
        this.webBookingHead.rowStatus = 10;
        this.webBookingHead.bookingHeadWebId = null;
      }
      if (this.detialType == 'New') {
        this.webBookingHead.remark = this.webBookingHead.remarkFromOutbound;
      }
      if ((0, _validate.validateNull)(this.voyagesData)) {
        this.$message({
          message: this.$t('surveyApply.message.checkVVL'),
          dangerouslyUseHTMLString: true,
          type: 'warning'
        });
        return;
      }
      var params = {
        voyages: this.voyagesData,
        webBookingHead: this.webBookingHead
      };
      if (this.detialType == 'Change') {
        this.webBookingHead.rowStatus = 16;
        (0, _bookingHistoryJp.saveOrUpdateBookingHeadWeb)(this.webBookingHead).then(function (res) {
          _this12.$message({
            message: _this12.$t('booking.bookingHistroryJpDetails.saveSuccess'),
            type: 'success'
          });
          _this12.$router.push('/bookingSpace/bookingHistoryJp');
        }).catch(function (err) {});
      } else {
        if (this.isTableItemTsFlag == '0') {
          console.log('直达');
          (0, _bookingHistoryJp.saveOrUpdateByVoyage)(params).then(function (res) {
            _this12.$message({
              message: _this12.$t('booking.bookingHistroryJpDetails.saveSuccess'),
              type: 'success'
            });
            _this12.$router.push('/bookingSpace/bookingHistoryJp');
          }).catch(function (err) {});
        } else {
          console.log('中转');
          (0, _bookingHistoryJp.saveOrUpdateByTsVoyage)(params).then(function (res) {
            _this12.$message({
              message: _this12.$t('booking.bookingHistroryJpDetails.saveSuccess'),
              type: 'success'
            });
            _this12.$router.push('/bookingSpace/bookingHistoryJp');
          }).catch(function (err) {});
        }
      }
    },
    delTag: function delTag(view) {
      this.$store.dispatch('tagsView/delView', this.$route).then(function (_ref5) {
        var visitedViews = _ref5.visitedViews;
      });
    },
    getStatusLabel: function getStatusLabel(value) {
      for (var i = 0; i < this.statusHeadData.length; i++) {
        if (value == this.statusHeadData[i].value) {
          console.log('this.statusHeadData.label', this.statusHeadData[i].label);
          this.statusLabel = this.statusHeadData[i].label;
        }
      }
      if (this.detialType == 'Copy') {
        this.statusLabel = 'NEW';
      }
    },
    getNowJpUserInfo: function getNowJpUserInfo() {
      var _this13 = this;
      (0, _bookingHistoryJp.getJpInfo)().then(function (res) {
        var userObject = _this13.$store.state.user.userInfo;
        _this13.custerInfo.companyName = userObject.simisCompanyNameEn;
        _this13.custerInfo.companyCode = userObject.simisCompanyCode;
        _this13.custerInfo.activateEmail = userObject.activateEmail;
        _this13.custerInfo.accountName = userObject.accountName;
        _this13.custerInfo.fax = res.data.expFaxNo;
        _this13.custerInfo.tel = res.data.mobilePhone;
        _this13.webBookingHead.webBkCustomers[0].customerName = _this13.custerInfo.companyName;
        _this13.webBookingHead.webBkCustomers[0].customerCode = _this13.custerInfo.companyCode;
        _this13.webBookingHead.webBkCustomers[0].webBkCustomerCatalogs[0].catalogContent = _this13.custerInfo.companyName;
        console.log('++++++++++++ this.webBookingHead.webBkCustomers[0].customerName', _this13.webBookingHead.webBkCustomers[0].customerName);
        _this13.getCustomerData(_this13.custerInfo.companyName);
      }).catch(function (err) {});
    },
    getDetailFormData: function getDetailFormData() {
      var _this14 = this;
      (0, _bookingHistoryJp.loadBookingHeadWebInitProps)(this.detailsId).then( /*#__PURE__*/function () {
        var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(res) {
          return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _this14.getStatusLabel(res.data.status);
                // this.webBookingHead.por=await this.getPortName(res.data.por)
                _this14.webBookingHead = res.data;
                _context.next = 4;
                return _this14.getPortName(res.data.por);
              case 4:
                _this14.polNameList.porName = _context.sent;
                _context.next = 7;
                return _this14.getPortName(res.data.pod);
              case 7:
                _this14.polNameList.podName = _context.sent;
                _context.next = 10;
                return _this14.getPortName(res.data.pol);
              case 10:
                _this14.polNameList.polName = _context.sent;
                _context.next = 13;
                return _this14.getPortName(res.data.del);
              case 13:
                _this14.polNameList.delName1 = _context.sent;
                if (!(_this14.webBookingHead.tsFlag == '1')) {
                  _context.next = 18;
                  break;
                }
                _context.next = 17;
                return _this14.getPortName(res.data.del);
              case 17:
                _this14.polNameList.delName = _context.sent;
              case 18:
                // console.log('+++++++++++++++res.data.webBkRoutings',res.data.webBkRoutings)
                // this.getMulitVoyageData(res.data.webBkRoutings)
                // this.voyagesData=res.data.webBkRoutings
                // console.log('++++++++++++ this.voyagesData',this.voyagesData)

                if (res.data.webBkCargos.length > 0) {
                  if (res.data.webBkCargos[0].webBkImos.length > 0) {
                    _this14.emergencyTelNoData[0].emergencyTelNo = res.data.webBkCargos[0].webBkImos[0].emergencyTelNo;
                  }
                }
                if (res.data.webBkCustomers.length > 1) {
                  _this14.deliveryDocumentCompany = res.data.webBkCustomers[1].customerName;
                  console.log(' this.deliveryDocumentCompany', _this14.deliveryDocumentCompany);
                }
                // 如果类型为
                if (_this14.$route.query.type === 'Preview' || _this14.webBookingHead.tsFlag === 1 && _this14.$route.query.type === 'Change') {
                  _this14.voyagesData = _this14.webBookingHead.webBkRoutings.map(function (item) {
                    return {
                      vesselName: item.vesselName,
                      //
                      voyageNo: item.voyageNo,
                      //
                      voyageLeg: item.voyageLeg ? item.voyageLeg : '',
                      polEtaHidden: item.portFromEta,
                      //POL ETA
                      polEta: item.portFromEta,
                      etd: item.portFromEtd,
                      //开航时间 POL ETD
                      eta: item.portToEta,
                      // 抵港时间  POD ETA
                      vesselCode: item.vesselCode,
                      serviceLineCode: item.serviceLineCode,
                      lineType: item.lineType,
                      tripNumber: item.tripNumber,
                      // Trip No
                      carrier: item.carrier,
                      polHidden: item.portFrom,
                      // portFrom
                      podHidden: item.portTo // portTo
                    };
                  });
                }
                // 拷贝的时候给对应的id置空
                if (_this14.$route.query.type === 'Copy') {
                  _this14.webBookingHead.blNo = '';
                  _this14.webBookingHead.bkNo = '';
                  _this14.webBookingHead.webBkCustomers = [{
                    rowStatus: 4,
                    customerName: '',
                    customerCode: '',
                    customerType: 0,
                    webBkCustomerCatalogs: [{
                      rowStatus: 4,
                      sequence: 1,
                      printOrder: 1,
                      catalogContent: ''
                    }]
                  }];
                  _this14.getNowJpUserInfo();
                  _this14.webBookingHead.webBkAks.length && _this14.webBookingHead.webBkAks.forEach(function (item) {
                    item.bkAkWebId = null;
                    item.bookingHeadWebId = null;
                  });
                  _this14.webBookingHead.webBkCargos.length && _this14.webBookingHead.webBkCargos.forEach(function (item) {
                    item.bkCargoWebId = null;
                    item.bookingHeadWebId = null;
                    item.webBkImos.length && item.webBkImos.forEach(function (item) {
                      item.bkImoWebId = null;
                      item.bkCargoWebId = null;
                    });
                    item.webBkReefers.length && item.webBkReefers.forEach(function (item) {
                      item.bkReeferWebId = null;
                      item.bkCargoWebId = null;
                    });
                  });
                  _this14.webBookingHead.webBkExtends.length && _this14.webBookingHead.webBkExtends.forEach(function (item) {
                    item.bkExtendWebId = null;
                    item.bookingHeadWebId = null;
                  });
                  _this14.webBookingHead.webBkFeeItems.length && _this14.webBookingHead.webBkFeeItems.forEach(function (item) {
                    item.bkFeeItemWebId = null;
                    item.bookingHeadWebId = null;
                  });
                  _this14.webBookingHead.webBkHgs.length && _this14.webBookingHead.webBkHgs.forEach(function (item) {
                    item.bkHgsWebId = null;
                    item.bookingHeadWebId = null;
                  });
                  _this14.webBookingHead.webBkPreContainers.length && _this14.webBookingHead.webBkPreContainers.forEach(function (item) {
                    item.bkPreContainerWebId = null;
                    item.bookingHeadWebId = null;
                  });
                  _this14.webBookingHead.webBkRoutings = [];
                  _this14.webBookingHead.webBkYards.length && _this14.webBookingHead.webBkYards.forEach(function (item) {
                    item.bkYardWebId = null;
                    item.bookingHeadWebId = null;
                  });
                }
                // 保存有id的删除数据
                _this14.webBookingHead.deleteWebBkPreContainers = [];
                _this14.webBookingHead.deleteWebBkImos = [];
                _this14.webBookingHead.deleteWebBkReefers = [];
                _this14.webBookingHead.deleteWebBkAks = [];

                // this.voyagesData[0].vesselName=res.data.webBkRoutings[0].vesselName
                // this.voyagesData[0].voyageNo=res.data.webBkRoutings[0].voyageNo
                // this.voyagesData[0].voyageLeg=res.data.webBkRoutings[0].voyageLeg
                // this.voyagesData[0].polEtaHidden=res.data.webBkRoutings[0].polEtaHidden
                // this.voyagesData[0].polEta=res.data.webBkRoutings[0].polEta
                // this.voyagesData[0].etd=res.data.webBkRoutings[0].etd
                // this.voyagesData[0].eta=res.data.webBkRoutings[0].eta
                // this.voyagesData[0].vesselCode=res.data.webBkRoutings[0].vesselCode
                // this.voyagesData[0].vesselNameCn=res.data.webBkRoutings[0].vesselNameCn
                // this.voyagesData[0].serviceLineCode=res.data.webBkRoutings[0].serviceLineCode
                // this.voyagesData[0].lineType=res.data.webBkRoutings[0].lineType
                // this.voyagesData[0].tripNumber=res.data.webBkRoutings[0].tripNumber
                // this.voyagesData[0].carrier=res.data.webBkRoutings[0].carrier
                // this.voyagesData[0].polHidden=res.data.webBkRoutings[0].portFrom
                // this.voyagesData[0].podHidden=res.data.webBkRoutings[0].portTo
                // console.log(' this.voyagesData', this.voyagesData)
              case 26:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref6.apply(this, arguments);
        };
      }()).catch(function (err) {
        console.log('err', err);
      });
    },
    getPortName: function () {
      var _getPortName = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(keyword) {
        var data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              data = {};
              data.portCode = keyword;
              data.portNameCn = keyword;
              data.portName = keyword;
              if (data.portCode) {
                data.portCode = '%' + data.portCode + '%';
              }
              if (data.portNameCn) {
                data.portNameCn = '%' + data.portNameCn + '%';
              }
              if (data.portName) {
                data.portName = '%' + data.portName + '%';
              }
              return _context2.abrupt("return", new Promise(function (resolve, reject) {
                (0, _booking.queryListPort)(data).then(function (res) {
                  console.log(' res.data.records[0].portName', res.data.records[0].portName);
                  resolve(res.data.records[0].portName);
                });
              }));
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function getPortName(_x2) {
        return _getPortName.apply(this, arguments);
      }
      return getPortName;
    }(),
    getPortCode: function getPortCode(keyword) {
      var data = {};
      data.portCode = keyword;
      data.portNameCn = keyword;
      data.portName = keyword;
      if (data.portCode) {
        data.portCode = '%' + data.portCode + '%';
      }
      if (data.portNameCn) {
        data.portNameCn = '%' + data.portNameCn + '%';
      }
      if (data.portName) {
        data.portName = '%' + data.portName + '%';
      }
      return (0, _booking.queryListPort)(data).then(function (res) {
        return res.data.records[0].portCode;
      });
    }
  }
};